// extracted by mini-css-extract-plugin
module.exports = {"Form":"Slider_Form__2IvIh"};